import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './prompt.reducer';

const FieldLabel = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
    {children}
  </Typography>
);

const FieldValue = ({ children, sx }: { children: React.ReactNode; sx?: object }) => (
  <Typography variant="body1" sx={{ mb: 2, ...sx }}>
    {children || '-'}
  </Typography>
);

export const PromptDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const promptEntity = useAppSelector(state => state.prompt.entity);
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <h2 data-cy="promptDetailsHeading">
          <Translate contentKey="jhipsterSampleApplicationApp.prompt.detail.title">Prompt</Translate>
        </h2>
        {promptEntity.id && (
          <Box sx={{ bgcolor: 'primary.light', color: 'primary.contrastText', px: 2, py: 0.5, borderRadius: 1, fontWeight: 'bold' }}>
            ID: {promptEntity.id}
          </Box>
        )}
      </Box>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.prompt.key" />
          </FieldLabel>
          <FieldValue>{promptEntity.key}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.prompt.value" />
          </FieldLabel>
          <FieldValue sx={{ whiteSpace: 'pre-wrap' }}>{promptEntity.value}</FieldValue>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.prompt.language" />
          </FieldLabel>
          <FieldValue>{promptEntity.language ? promptEntity.language.code : ''}</FieldValue>
        </Grid>

        <Grid size={12}>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button component={Link} to="/prompt" replace color="info" variant="outlined" startIcon={<FontAwesomeIcon icon="arrow-left" />}>
              <Translate contentKey="entity.action.back">Back</Translate>
            </Button>
            <Button
              component={Link}
              to={`/prompt/${promptEntity.id}/edit`}
              replace
              color="primary"
              variant="contained"
              startIcon={<FontAwesomeIcon icon="pencil-alt" />}
            >
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PromptDetail;
